import type { Language } from "../../contexts/LanguageContext";

export const subscriptionLabels: Record<Language, {
  loading: string;
  currentPlan: string; // uses {plan}
  nextRenewal: string;
  manage: string;
}> = {
  pt: {
    loading: "Carregando...",
    currentPlan: "Plano {plan}",
    nextRenewal: "Próxima renovação",
    manage: "Gerenciar assinatura",
  },
  en: {
    loading: "Loading...",
    currentPlan: "Plan {plan}",
    nextRenewal: "Next renewal",
    manage: "Manage subscription",
  },
};

